import { createContext, useContext, useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import * as serviceWorker from './serviceWorkerRegistration';

const AppUpdateContext = createContext({
  showReload: false,
  reloadPage: () => {},
});

export const useAppUpdate = () => useContext(AppUpdateContext);

const AppUpdate = ({ children }) => {
  const [showReload, setShowReload] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  const onSWUpdate = (registration) => {
    setShowReload(true);
    setWaitingWorker(registration.waiting);
  };

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      serviceWorker.register({ onUpdate: onSWUpdate });
    }
  }, []);

  const reloadPage = () => {
    waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
    setShowReload(false);
    window.location.reload(true);
  };

  return (
    <AppUpdateContext.Provider value={{ showReload, reloadPage }}>
      {children}
    </AppUpdateContext.Provider>
  );
};

export default AppUpdate;
